module.exports = __webpack_public_path__ + "img/choice_dn_lf.909915e5.png";